import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { FaqStyle, ContentStyle } from "../../Theme";
import useCollapse from "react-collapsed";
import FaqArrowIcon from "../../images/icons/FaqArrowIcon.svg";
import { YSButton } from "../../uikit/YSButton";
import VideocamIcon from "@mui/icons-material/Videocam";
import LinkIcon from "@mui/icons-material/Link";

function FaqBoxStyle(props: any) {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  return (
    <FaqStyle className={isExpanded ? " active" : ""}>
      <Box className={"header"} {...getToggleProps()}>
        <Typography component="div" color="primary" variant="body2">
          {props.title}{" "}
          <img src={FaqArrowIcon} alt="Show/Hide" loading="lazy" />
        </Typography>
      </Box>
      <Box className="content" {...getCollapseProps()}>
        {props.content}
      </Box>
    </FaqStyle>
  );
}

export default function Faqs() {
  return (
    <>
      <ContentStyle>
        <Typography component="h6" color="primary" variant="h6">
          Frequently asked questions
        </Typography>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          alignItems="flex-start"
          justifyContent="flex-start"
          rowSpacing={4}
        >
          <Grid item xs={12}>
            <FaqBoxStyle
              title={
                <>
                  What is 'on behalf prescribing'? What is the set up procedure
                  for this?
                </>
              }
              content={
                <>
                  {" "}
                  <Typography component="div" variant="body2">
                    On behalf prescribing is a process which enables a provider
                    to set up a non-provider to prescribe New Rx's and /or
                    refills on his/her behalf in his/her absence. It requires
                    the provider to select 'staff authorization' on the left
                    tool bar of his/her profile page under the 'change password'
                    button leading to a screen displaying all the enrolled users
                    in the practice with check boxes for OBN and OBR. If the
                    nurse will be sending only refills then only 'OBR' has to be
                    selected and if selecting for both New and Refills then
                    checking only 'OBN' would activate both. Selection of proper
                    boxes is extremely important!
                  </Typography>
                  <Typography component="div" variant="body2">
                    The nurse can now log in using his/her own credentials and
                    choose the 'on behalf' link which will then display a screen
                    where he/she will be prompted to choose the provider on
                    behalf of whom he/she would be prescribing. The Rx pad
                    screen will then display the name of the particular provider
                    (next to 'on behalf') and the nurse can now proceed with the
                    prescribing process and will have the 'send to pharmacy' and
                    'print' options enabled.
                  </Typography>
                  <YSButton
                    size="small"
                    className="w150"
                    color="primary"
                    id="submitBtn"
                    variant="contained"
                    disabled={false}
                    type="button"
                    children={"Click to View"}
                    onClick={() => {
                      window.open(
                        `https://vimeo.com/568505582/e582ed77f9`,
                        "video"
                      );
                    }}
                    startIcon={<VideocamIcon />}
                  />
                </>
              }
            />
            <FaqBoxStyle
              title={<>How to set up a new mobile device with id.me?</>}
              content={
                <>
                  {" "}
                  <Typography component="div" variant="body2">
                    Here is the link to setup your new mobile device with id.me.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    Note: These steps need to be followed from your new mobile
                    device.
                  </Typography>
                  <YSButton
                    size="small"
                    className="w150"
                    color="primary"
                    id="submitBtn"
                    variant="contained"
                    disabled={false}
                    type="button"
                    children={"Resource"}
                    onClick={() => {
                      window.open(
                        `https://help.id.me/hc/en-us/articles/360017927633-How-do-I-update-my-phone-number-for-MFA-`,
                        "url"
                      );
                    }}
                    startIcon={<LinkIcon />}
                  />
                </>
              }
            />
            <FaqBoxStyle
              title={
                <>
                  What to do if you get invalid code error even after entering
                  the correct code from id.me authenticator app?
                </>
              }
              content={
                <>
                  {" "}
                  <Typography component="div" variant="body2">
                    First basic resolution is check time and date of the mobile
                    device if not fixed then follow below steps.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    1. On your computer, sign in to your ID.me My Account page.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    2. Click the Sign in and Security tab and select a
                    multi-factor authentication (MFA) method and select Text
                    Message/Phone call.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    3. On the Secure your Account screen, select Code Generator
                    Application. Delete any device currently enrolled with the
                    code generator by clicking the trash can icon.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    4. You will then select "Add" to re-enroll your device. You
                    will see the option text message for a link to be sent to
                    download the app (attempt reconnecting the device with this
                    option or skip to step 5).
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    5. On that same screen scroll down a little bit and Tap the
                    Enroll with Bar Code/Secret Key button, and use your device
                    to scan the QR/barcode on your computer screen. (NOTE: In
                    your mobile device's settings, make sure the app has
                    permission to use the device's camera.)
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    6. When the code is successfully scanned, click Continue on
                    your computer
                  </Typography>
                  <Typography component="div" variant="body2">
                    The ID.me Authenticator app should now display a 6-digit
                    code. (NOTE: Codes are refreshed every 30 seconds.) On your
                    computer, enter the code from your mobile device on the
                    Secure your account screen. You should see a message that
                    your Account is now secured.
                  </Typography>
                </>
              }
            />
            <FaqBoxStyle
              title={
                <>
                  What exactly is the refill workflow like? What is the
                  difference between refills and renewals?
                </>
              }
              content={
                <>
                  {" "}
                  <Typography component="div" variant="body2">
                    When the prescriber issues a New Rx to a patient, they can
                    also approve some refills along with that. And, the patient
                    can go to the pharmacy and get the approved refills
                    dispensed. When the approved refills run out and the patient
                    goes to the pharmacy, the pharmacy will see if the
                    prescriber is enabled to receive electronic refills. If so,
                    they can request for one or more refills and these will
                    appear in the users refill bucket at the top of the page.
                    The prescriber can approve or deny these requests and that
                    response is sent back to the pharmacy. Important point to be
                    noted is that the 'prescriber must be enabled for refills'.
                  </Typography>{" "}
                  <Typography component="div" variant="body2">
                    Renewals (renewing a prescription already prescribed through
                    our application) on the other hand are like New Rx's only
                    which are selected and prescribed through medication
                    history.
                  </Typography>
                </>
              }
            />
            <FaqBoxStyle
              title={<>What do 'refills' in our application stand for?</>}
              content={
                <Typography component="div" variant="body2">
                  Refills in our application mean electronic refills that the
                  patient can request through the pharmacy where the refill
                  request will be sent by the pharmacy to the prescriber and we
                  will show it in the Refill or Refill alert links you see at
                  the top of the screen.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={<>What is the drop down list of prescribers for?</>}
              content={
                <Typography component="div" variant="body2">
                  The drop down list is just for saving prescriptions for
                  prescribers by the non- prescribers and should not be confused
                  for 'on behalf' prescribing.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={<>What does it mean by 'pending refill alerts'?</>}
              content={
                <Typography component="div" variant="body2">
                  It is the same as pending refills, the requests coming from
                  the pharmacies. But, when we get the request, we try to match
                  is up against the original New Rx, the patient name, DOB etc
                  in the request versus what we have in our DB and if does not
                  match , we throw it into the alert bucket. So, the user will
                  have the option to confirm that the request is valid for the
                  patient and take appropriate action.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={
                <>What needs to be done for 'add to medication history'?</>
              }
              content={
                <Typography component="div" variant="body2">
                  Enter the prescription on the Rx Pad page, confirm the
                  prescription, on the confirm prescription page check the box
                  against each of the prescription you want to add and click on
                  'Add to medication history' tab at the bottom of the page.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={
                <>
                  Is there a way to track, get the status or confirmation with
                  pharmacy on an Rx sent using the application?
                </>
              }
              content={
                <Typography component="div" variant="body2">
                  If you go to patient's medication history screen, it shows a
                  status field. If it says E*S, it means it was electronically
                  sent and was received by the pharmacy. When we sent the script
                  to the pharmacy, we update the status as successful only when
                  we get a confirmation from the pharmacy that it has been
                  received. Unfortunately, this is all the confirmation we have
                  currently. But, in future we will have another transaction
                  from the pharmacies that will show the fill status of the
                  prescription where it will indicate whether the Rx was
                  dispensed and picked up by the patient.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={<>What is the default physician logic?</>}
              content={
                <Typography component="div" variant="body2">
                  The default physician logic is tied to a patient. So, if you
                  set it once for a patient, next time the same patient is
                  selected, the default physician selected previously will show
                  up. Typically, it is not tied to a user.
                </Typography>
              }
            />
            <FaqBoxStyle
              title={<>How do you cancel a prescription and rewrite it?</>}
              content={
                <Typography component="div" variant="body2">
                  Go to medication history, select the medication to be canceled
                  and click on 'inactivate drug'. Then write the prescription
                  again with the proper number of refills. You will also need to
                  communicate to the pharmacy that the first prescription is
                  canceled.
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </ContentStyle>
    </>
  );
}
